import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { GESTION, SAISIE, ALL, homeFor } from "@/lib/roles";

import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import NouvellePalette from "@/pages/NouvellePalette";
import EtiquettePalette from "@/pages/EtiquettePalette";
import ListePalettes from "@/pages/ListePalettes";
import NouveauBL from "@/pages/NouveauBL";
import DetailBL from "@/pages/DetailBL";
import HistoriqueBL from "@/pages/HistoriqueBL";
import Bilan from "@/pages/Bilan";
import BilanAnnuel from "@/pages/BilanAnnuel";
import Admin from "@/pages/Admin";
import PublicTrace from "@/pages/PublicTrace";
import ModifierPalette from "@/pages/ModifierPalette";
import AideImprimante from "@/pages/AideImprimante";
import ProductionJour from "@/pages/ProductionJour";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse font-heading text-2xl uppercase tracking-widest text-muted-foreground">
          Chargement…
        </div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}

function Home() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  return <Navigate to={user ? homeFor(user.role) : "/login"} replace />;
}

const R = (roles, el) => <Protected roles={roles}>{el}</Protected>;

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/p/:code" element={<PublicTrace />} />
      <Route path="/palette/:id/etiquette" element={R(SAISIE, <EtiquettePalette />)} />

      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={R(GESTION, <Dashboard />)} />
        <Route path="/nouvelle-palette" element={R(SAISIE, <NouvellePalette />)} />
        <Route path="/production" element={R(SAISIE, <ProductionJour />)} />
        <Route path="/palettes" element={R(GESTION, <ListePalettes />)} />
        <Route path="/palette/:id/modifier" element={R(GESTION, <ModifierPalette />)} />
        <Route path="/bl" element={R(ALL, <HistoriqueBL />)} />
        <Route path="/bl/nouveau" element={R(SAISIE, <NouveauBL />)} />
        <Route path="/bl/:id" element={R(ALL, <DetailBL />)} />
        <Route path="/bilan" element={R(GESTION, <Bilan />)} />
        <Route path="/bilan/annuel" element={R(GESTION, <BilanAnnuel />)} />
        <Route path="/aide/imprimante" element={<AideImprimante />} />
        <Route path="/admin" element={R(["admin"], <Admin />)} />
      </Route>

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
